/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @type {Array} The array filled with exceptions.
 */
export default [
	// Definite articles:
	"ten",
	// Numbers 0-10, 100, 1000:
	"nula", "jeden", "jedné", "jedna", "jedno", "dva", "dvě", "dvou", "tři", "čtyři", "pět", "šest", "sedm", "osm",
	"devět", "deset", "sto", "tisíc",
	// Demonstrative pronouns ("ten" is already added above):
	"tento", "ta", "tato", "to", "toto", "ti", "tito",
	// Interrogatives:
	"kdo", "co",
];
